export const PORTAL_CLASS_NAME = 'ds-moved-with-portal'
